import styled from 'styled-components';

export const StyledNotesListItemHeader = styled.div`
   display: flex;
   flex: 1;
   justify-content: space-between;
   > :last-child {
      display: inline-flex;
   }
`;

StyledNotesListItemHeader.displayName = 'StyledNotesListItemHeader';
